export default {
  ls3df: {
    describe:`
    LS3DF(Linear Scaling Three Dimensional Fragment Method)算法基于分而治之的思想，
    将大体系划分为许多小片段，每个小片段单独用DFT方法进行计算，然后将计算完的小片段组合拼接起来，
    从而得到大体系的电子结构性质。目前LS3DF支持电子结构自洽计算和结构优化计算。
    LS3DF软件包与PWmat使用同样的认证证书，如果服务器已有PWmat证书文件，无需重新申请或者安装。
    下面所列安装包均采用GPU卡UUID认证LICENSE的方式，龙讯根据用户提供的UUID产生证书文件pwmat.lic，
    该证书文件需要放在服务器/opt/pwmat/文件夹下。如用户没有服务器root权限，
    无法将证书文件放在/opt/pwmat/目录下，可以在运行LS3DF时，
    在LS3DF后跟-lic-path参数指定LICENSE文件所在的文件夹：LS3DF -lic-path 'path-to-pwmat.lic'。
    除超算中>心以及大规模集群,绝大部分用户均下载该版本进行软件安装或者更新。
    用户下载LS3DF安装包前，请首先确认自己服务器上MPI以及CUDA版本，根据对应关系下载安装包。
    如有任何操作不明之处请及时联系龙讯工作人 员或发送邮件到support@pwmat.com！！！
    `,
    tableR0C3: 'LS3DF 版本',
    note1: 'LS3DF 安装说明',
    describe2: `
    下面所列安装包均采用在集群登录或者管理节点启动server.py服务认证LICENSE的方式，
    超算中心或大规模集群用户均下载该版本进行软件安装或者更新。用户下载LS3DF安装包前，
    请首先确认自己服务器上MPI以及CUDA版本，根据对应关系下载安装包。特别注意，运行该版本LS3DF时，
    需要在LS3DF指定部署LICENSE服务的节点的IP以及通讯端口，IP和通讯端口设置方法请参考LICENSE服务安装说明！！！

    `,
  },
  matpl: {
    describe:`
    Materials Potential Library (MatPL) 是由原PWMLFF发展而来，在GNU许可下开放源代码，
    用于快速生成机器学习力场，这些力场的精度可以与从头算分子动力学 (AIMD) 相媲美。
    `,
    describe2:`
    MatPL 提供了一整套的解决方案，包括机器学习力场模型训练平台、Lammps接口方案、主动学习平台、数据格式转换工具等。
    此外，它还提供了数据和模型仓库，以及详细的用户手册。这些功能和资源为用户提供了全方位的支持，
    使得用户可以更方便、更高效地使用 MatPL 进行科学计算和模拟。
    `,
    tableR0C1: '版本',
    tableR0C2: '发布日期 ',
    tableR0C3: '依赖库版本',
    tableR0C4: '安装包链接',
    tableR0C5: '手册链接',
  },
}